import React from "react";
import { MailIcon } from "./mail-icon";
import "./styles.m.css";

const NewsletterSubscribeButton = () => {
  return (
    <a styleName="cta-newsletter" href="/subscribe" target="_blank">
      <MailIcon />
      Subscribe Newspaper
    </a>
  );
};

export { NewsletterSubscribeButton };
